import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { createComponent, ThemeProvider, withTheme } from '@ycos/fela'
import GridOverlay from './../grid-overlay'

const GridOverlayContainer = createComponent('div', () => ({
  position: 'relative'
}))

class GridOverlayWrapper extends PureComponent {
  render() {
    return (
      <GridOverlayContainer>
        {this.props.children}
        <ThemeProvider theme={{ ...this.props.theme, direction: 'ltr' }}>
          <GridOverlay breakpoints={this.props.breakpoints} />
        </ThemeProvider>
      </GridOverlayContainer>
    )
  }
}

GridOverlayWrapper.contextTypes = {
  breakpoints: PropTypes.object
}

export default withTheme(GridOverlayWrapper)
